import campaignNamesForCustomer, {
  getCampaignNameFromCategory
} from 'main/campaignNamesAndDesc'

export function getCampaignTitle(campaign) {
  if (campaign.type === 'consentRequest') {
    return getCampaignNameFromCategory(campaign.category) || 'Default text'
  }

  if (campaign.type === 'nonOTAVariant') {
    return 'For direct guests'
  }

  if (campaign.type === 'OTAVariant') {
    return 'For OTA guests'
  }

  if (campaign.category === 'OptInRequest') {
    return 'Widget consent request'
  }

  if (campaign.category === 'CardAbandonmentOptedIn') {
    return 'Widget welcome'
  }

  if (campaign.category === 'ReviewReminder1') {
    return 'Reminder (one day after request)'
  }

  if (campaign.category === 'ReviewReminder2') {
    return '2nd reminder (two days after request)'
  }

  return campaignNamesForCustomer[campaign.category] || campaign.category
}
